import { get, post, postKeepalive } from "../../../../services/request";

export const acquireTaskSequenceLock = (data = {}) => post("Task/AcquireTaskSequenceLock", data);
export const releaseTaskSequenceLock = (data) => post("Task/ReleaseTaskSequenceLock", data);
export const releaseTaskSequenceLockOnPageExit = (data) => postKeepalive("Task/ReleaseTaskSequenceLock", data);

// Site Coverage Services
export const getAllSiteCoverageDetails = (payload) => {
  return post("SiteCoverage/GetAllSiteCoverageDetails", payload);
};

export const getSiteCoverageDetailByID = (siteCoverageID) => {
  return get(
    `SiteCoverage/GetSiteCoverageDetailByID?siteCoverageID=${siteCoverageID}`,
  );
};

export const deleteSiteCoverageDetail = (data) => {
  return post("SiteCoverage/DeleteSiteCoverageDetail", data);
};

export const saveSiteCoverageDetail = (data) => {
  return post("SiteCoverage/SaveSiteCoverageDetail", data);
};

//-------------------Coverage Gap ----------------//
//Get All Coverage Gap
export const getCoverageGap = () => {
  return get("RVUConfiguration/GetAllRVUConfiguration");
};

//Get Coverage Gap By ID
export const getCoverageGapByID = (coverageGapID) => {
  return get(
    `RVUConfiguration/GetRVUConfigurationByID?RVUConfigurationID=${coverageGapID}`,
  );
};

//Save Coverage Gap
export const saveCoverageGap = (data) => {
  return post("RVUConfiguration/SaveRVUConfiguration", data);
};

//Delete Coverage Gap
export const deleteCoverageGap = (coverageGapIDId, modifiedBy) => {
  return post("RVUConfiguration/DeleteRVUConfiguration", {
    RVUConfigurationID: coverageGapIDId,
    ModifiedBy: modifiedBy,
  });
};

//-------------------End Coverage Gap ----------------//

// Priority SLA Mapping Services
export const getAllPrioritySLAMappings = () => {
  return get("PrioritySLA/GetAllPrioritySLA");
};

export const getPrioritySLAMappingById = (mappingId) => {
  return get(
    `PrioritySLA/GetPrioritySLAByID?PrioritySLAMappingID=${mappingId}`,
  );
};

export const savePrioritySLAMapping = (mappingData) => {
  return post("PrioritySLA/SavePrioritySLA", mappingData);
};

export const deletePrioritySLAMapping = (mappingId, modifiedBy) => {
  return post("PrioritySLA/DeletePrioritySLA", {
    PrioritySLAMappingID: mappingId,
    ModifiedBy: modifiedBy,
  });
};

export const getPriorityDropdown = () => {
  return get("Priority/GetAllPriority");
};

export const activateDeactivatePrioritySLAMapping = (
  mappingId,
  status,
  userId,
) => {
  return post("PrioritySLA/ActivateDeactivate", {
    Id: mappingId,
    Status: status,
    UserId: userId,
  });
};

export const getPriorityBucketsForPrioritySLA = () => {
  return get("PrioritiesManagement/GetAllPriorityBuckets");
};

// License Mapping Services
export const getStateLicenseMapping = () => {
  return get("LicensePrivilegeMapping/GetLicenseMapping");
};

export const getStateLicenseMappingDropdown = () => {
  return get("LicensePrivilegeMapping/GetLicenseMappingDropdown");
};

export const saveStateLicenseMappingBulk = (data) => {
  return post("LicensePrivilegeMapping/SaveLicenseMappingBulk", data);
};

export const getDefineMismatch = () => {
  return get("LicensePrivilegeMapping/GetDefineMismatch");
};

export const getDefineMismatchDropdown = () => {
  return get("LicensePrivilegeMapping/GetDefineMismatchDropdown");
};

export const saveDefineMismatch = (data) => {
  return post("LicensePrivilegeMapping/SaveDefineMismatch", data);
};

export const activateDeactivateDefineMismatch = (data) => {
  return post("LicensePrivilegeMapping/ActiveDeactivateDefineMismatch", data);
};

export const deleteDefineMismatch = (data) => {
  return post("LicensePrivilegeMapping/DeleteDefineMismatch", data);
};

// Privileges Mapping Services
export const getPrivilegesMapping = () => {
  return get("LicensePrivilegeMapping/GetAllPrivilegesMapping");
};

export const getPrivilegesMappingDropdown = () => {
  return get("LicensePrivilegeMapping/GetPrivilegesMappingDropdown");
};

export const savePrivilegesMappingBulk = (data) => {
  return post("LicensePrivilegeMapping/SavePrivilegesMappingBulk", data);
};

// Reading Status Mapping Services
export const getReadingStatusMapping = () => {
  return get("LicensePrivilegeMapping/GetAllReadingStatusMapping");
};

export const getReadingStatusMappingDropdown = () => {
  return get("LicensePrivilegeMapping/GetReadingStatusMappingDropdown");
};

export const saveReadingStatusMappingBulk = (data) => {
  return post("LicensePrivilegeMapping/SaveReadingStatusMappingBulk", data);
};


// Shift Hour Configuration Services
export const getShiftHourConfiguration = () => {
  return get("ShiftHourConfiguration/GetAllShiftHourConfiguration");
};

//--------------------- DLS Configuration Services - Start---------------------//
export const getAllDLSConfiguration = () => {
  return get("DLSConfiguration/GetAllDLSConfiguration");
};

export const getSitesWithoutDLS = () => {
  return get("DLSConfiguration/GetAllDLSConfiguration");
};

export const saveDLSConfiguration = (data) => {
  return post("DLSConfiguration/SaveDLSConfiguration", data);
};
//--------------------- DLS Configuration Services - End---------------------//

//Block Planning Services
export const getAllBlockPlanning = () => {
  return get(
    "BlockPlanningColorConfiguration/GetAllBlockPlanningColorConfiguration",
  );
};
export const getBlockPlanningDetailByID = (
  blockPlanningColorConfigurationID,
) => {
  return get(
    `BlockPlanningColorConfiguration/GetBlockPlanningColorConfigurationByID?blockPlanningColorConfigurationID=${blockPlanningColorConfigurationID}`,
  );
};

export const deleteBlockPlanning = (
  BlockPlanningColorConfigurationID,
  ModifiedBy,
) => {
  return post(
    "BlockPlanningColorConfiguration/DeleteBlockPlanningColorConfiguration",
    {
      BlockPlanningColorConfigurationID: BlockPlanningColorConfigurationID,
      ModifiedBy: ModifiedBy,
    },
  );
};
export const saveBlockPlanning = (blockPlanningData) => {
  return post(
    "BlockPlanningColorConfiguration/SaveBlockPlanningColorConfiguration",
    blockPlanningData,
  );
};

//--------------------- Day of Week Configuration Services - Start---------------------//
export const getAllDayOfWeekConfiguration = () => {
  return get("DayOfWeekConfiguration/GetAllDayOfWeekConfiguration");
};
//--------------------- Day of Week Configuration Services - End---------------------//
// Task Configuration Services
export const getAllTaskConfigurationDetails = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters?.taskName) {
    params.append("taskName", filters.taskName);
  }

  if (filters?.WorkListIDs) {
    params.append("WorkListIDs", filters.WorkListIDs);
  }

  if (typeof filters?.isActive === "boolean") {
    params.append("isActive", `${filters.isActive}`);
  }

  const queryString = params.toString();
  const url = queryString ? `Task/GetAllTask?${queryString}` : "Task/GetAllTask";
  return get(url);
};

export const saveTaskConfiguration = (taskConfigurationData) => {
  return post("Task/SaveTask", taskConfigurationData);
};

export const deleteTaskConfiguration = ({ TaskID, ModifiedBy, TaskName }) => {
  return post("Task/DeleteTask", {
    TaskID,
    ModifiedBy,
    TaskName,
  });
};

export const getTaskConfigurationById = (taskConfigurationID) => {
  return get(`Task/GetTaskByID?taskID=${taskConfigurationID}`);
};

export const getTaskFacilityOptions = (
  workListId = null,
  facilitiesTagIds = null,
  facilitiesTagMappings = null,
) => {
  const params = new URLSearchParams();
  if (workListId) {
    params.append("workListId", `${workListId}`);
  }
  if (facilitiesTagIds) {
    params.append("facilitiesTagIds", `${facilitiesTagIds}`);
  }
  if (facilitiesTagMappings) {
    params.append("facilitiesTagMappings", `${facilitiesTagMappings}`);
  }

  const query = params.toString();
  return get(`Task/GetFacilityOptions${query ? `?${query}` : ""}`);
};

export const getTaskFacilityTagOptions = () => {
  return get("Task/GetFacilityTagOptions");
};

export const getTaskWorklistSubspecialityOptions = (workListId = null) => {
  const query = workListId ? `?workListId=${workListId}` : "";
  return get(`Task/GetWorklistSubspecialityOptions${query}`);
};

// Activate/Deactivate Task configuration
export const activateDeactivateTaskConfiguration = (
  taskConfigurationID,
  isActive,
  userId,
) => {
  return post("Task/ActivateDeactivate", {
    Id: taskConfigurationID,
    Status: isActive,
    UserId: userId,
  });
};

export const saveTaskBulkUpdate = (data) => {
  return post("Task/TaskBulkUpdate", data);
};

// Save global Task sequence
export const saveTaskSequence = (data) => {
  return post("Task/SaveTaskSequence", data);
};

export const getTaskTagsByTaskId = (taskId) => {
  return get(`Task/GetTaskTagsByTaskID?taskID=${taskId}`);
};

export const saveTaskTags = (data) => {
  return post("Task/SaveTaskTags", data);
};

// Provider Task Pool Services
export const getProviderTaskPoolByTaskId = (taskId) => {
  return get(`TaskProviderPool/GetByTaskId?taskId=${taskId}`);
};

export const saveProviderTaskPool = (data) => {
  return post("TaskProviderPool/Save", data);
};

export const getProviderTaskPoolProviderOptions = (taskId) => {
  return get(`TaskProviderPool/GetProviderOptions?taskId=${taskId}`);
};

export const addProviderTaskPoolProviders = (data) => {
  return post("TaskProviderPool/AddProviders", data);
};

export const removeProviderTaskPoolProvider = (data) => {
  return post("TaskProviderPool/RemoveProvider", data);
};

export const exportProviderTaskPool = (taskId) => {
  return get(`TaskProviderPool/ExportToCSV?taskId=${taskId}`);
};

export const validateProviderTaskPoolSlotConcurrency = (data) => {
  return post("TaskProviderPool/ValidateSlotConcurrency", data);
};

//--------------------- Simulation color configuration - Start---------------------//
export const getAllSimulation = () => {
  return get("SimulatorColorConfiguration/GetAllSimulatorColorConfiguration");
};

export const saveSimulation = (simulationData) => {
  return post(
    "SimulatorColorConfiguration/SaveSimulatorColorConfiguration",
    simulationData,
  );
};

export const deleteSimulation = (SimulatorLegendId, modifiedBy) => {
  return post("SimulatorColorConfiguration/DeleteSimulatorColorConfiguration", {
    SimulatorLegendId: SimulatorLegendId,
    ModifiedBy: modifiedBy,
  });
};

export const getSimulationByID = (SimulatorLegendId) => {
  return get(
    `SimulatorColorConfiguration/GetSimulatorColorConfigurationByID?SimulatorLegendId=${SimulatorLegendId}`,
  );
};
//--------------------- Simulation color configuration - End---------------------//

//--------------------- Email Configuration - Start---------------------//
//Get All Email Recipient Configuration
export const getEmailRecipientConfiguration = () => {
  return get("EmailRecipientConfiguration/GetAllEmailRecipientConfiguration");
};

//Save Email Recipient User Emails
export const saveEmailRecipientUserEmails = (data) => {
  return post("EmailRecipientConfiguration/SaveEmailRecipientUserEmails", data);
};
//--------------------- Email Configuration - End---------------------//
